import {ClipboardModule, ClipboardService} from "ngx-clipboard";
import {CommonModule}               from '@angular/common';
import {FormsModule}                from "@angular/forms";
import {NgModule}                   from '@angular/core';
import {NgbTypeaheadModule}         from "@ng-bootstrap/ng-bootstrap";

import {CollegeTypeaheadComponent}  from './typeaheads/college/college-typeahead.component';
import {OnBlurDirective}            from "./directives/on-blur.directive";
import {OnlyLoggedInGuard}          from "./services/miscellaneous/only-logged-in.guard";
import {PlayerTypeaheadComponent}   from "./typeaheads/player/player-typeahead.component";
import {SourceTypeaheadComponent}   from "./typeaheads/source/source-typeahead.component";
import {TagTypeaheadComponent}      from './typeaheads/tag/tag-typeahead.component';
import {TeamTypeaheadComponent}     from "./typeaheads/team/team-typeahead.component";


/*
IMPORTANT NOTE WHEN ADDING TYPEAHEADS:

When adding a typeahead component, if it is shared between administrative modules and the article
pages, it must be put ONLY into the shared.module.ts file as both a declaration and an export.

*/

@NgModule({

	declarations: [

		CollegeTypeaheadComponent,
		OnBlurDirective,
		PlayerTypeaheadComponent,
		SourceTypeaheadComponent,
		TagTypeaheadComponent,
		TeamTypeaheadComponent,

	],

	imports: [

		ClipboardModule,
		CommonModule,
		FormsModule,
		NgbTypeaheadModule,

	],

	providers: [

		ClipboardService,
		OnlyLoggedInGuard,

	],

	exports: [

		ClipboardModule,
		CollegeTypeaheadComponent,
		OnBlurDirective,
		PlayerTypeaheadComponent,
		SourceTypeaheadComponent,
		TagTypeaheadComponent,
		TeamTypeaheadComponent,

	]

})


/**
 * This is required so the typeaheads can be shared between
 * the administrative and the article pages.
 */
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared.module.ts